import { render } from "./ProfileMLayout.vue?vue&type=template&id=39afda9c&scoped=true"
import script from "./ProfileMLayout.vue?vue&type=script&lang=js"
export * from "./ProfileMLayout.vue?vue&type=script&lang=js"

import "./ProfileMLayout.vue?vue&type=style&index=0&id=39afda9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39afda9c"]])

export default __exports__